import { CommsIcons } from '@soulhx/ui-common';
import React, { use, useMemo } from 'react';
import { Badge, Nav } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { SoulHXContext, type SoulHXContextType } from '../../../stores/SoulHXContext.js';
import { useGetUnreadCommentsForAdminQuery, useGetUnreadFeedbackForAdminQuery } from '@soulhx/client-store';

interface IHeaderCommsLink {
  eventKey: number;
}
export const HeaderCommsLink = ({ eventKey }: IHeaderCommsLink) => {
  const { t } = useTranslation();
  const { user } = use(SoulHXContext) as SoulHXContextType;
  const { data: unreadComments } = useGetUnreadCommentsForAdminQuery(undefined, { skip: !user.isAdmin });
  const { data: unreadFeedback } = useGetUnreadFeedbackForAdminQuery(undefined, { skip: !user.isAdmin });

  const unreadItems = useMemo(() => {
    let count = 0;

    if (unreadComments) count += unreadComments.length;
    if (unreadFeedback) count += unreadFeedback.length;

    return count;
  }, [unreadComments, unreadFeedback]);

  return (
    <Nav.Link
      as={NavLink}
      eventKey={eventKey}
      to="/comms"
      aria-label={t('header.linkNames.resources')}
      className="position-relative"
    >
      <CommsIcons type="general" className="fs-1" />
      {unreadItems > 0 && (
        <Badge bg="danger" pill className="position-absolute top-0 end-0 translate-top">
          {unreadItems > 99 ? '99+' : unreadItems}
          <span className="visually-hidden">{t('header.linkNames.unreadComments')}</span>
        </Badge>
      )}
    </Nav.Link>
  );
};
